/**
 * Regla unica para saber si un patron de calibracion es QDE- (incertidumbre "N/A").
 *
 * El nombre del patron puede venir vacio: filas anteriores a la migracion de QLOD-66
 * (name a NULL) o canales de multicanal cuya descripcion es texto libre. En ese caso
 * se cae al nombre del equipo, que es de donde salia el dato antes de QLOD-66. La
 * pantalla y el dialogo de patrones tienen que usar esta misma funcion: si cada uno
 * resuelve el nombre a su manera, uno guarda una incertidumbre donde el otro pinta N/A.
 */
export class PatternUtils {

  static resolvePatternName(pattern: { name?: string; equipment?: { name?: string } }): string {
    if (pattern == null) {
      return null;
    }
    const name = pattern.name?.trim();
    return name ? name : (pattern.equipment?.name ?? null);
  }

  /**
   * En un multicanal 'name' es la descripcion del canal ("Canal 1"), asi que ademas del nombre
   * resuelto se mira siempre el nombre del equipo, que es lo que usaba la tabla antes de QLOD-66.
   */
  static isQde(pattern: { name?: string; equipment?: { name?: string } }): boolean {
    if (pattern == null) {
      return false;
    }
    return (PatternUtils.resolvePatternName(pattern)?.includes('QDE-') ?? false)
      || (pattern.equipment?.name?.includes('QDE-') ?? false);
  }
}
